import { render, staticRenderFns } from "./LogisticsSidebar.vue?vue&type=template&id=65fef7ec&"
import script from "./LogisticsSidebar.vue?vue&type=script&lang=js&"
export * from "./LogisticsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports